import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ControllerBase } from '../_appCommon/base/ControllerBase';
import { AppClientContext }  from '../_appCommon/base/AppClientContext';
import { BroadcastManager } from '../_appCommon/base/BroadcastManager';
import { AppEventNames } from '../_appCommon/base/Constants';
import { SystemServicesDataService } from '../_dataservices/security/SystemServicesDataService';
import { CustomerDataService } from '../_dataservices/CustomerDataService'; 
import { ECOMMERCE_USER_TOKEN } from "src/app/_appCommon/base/Constants";
import { AnnouncementsService } from '../_dataservices/announcements-service.service';
import { UrlQueryDef } from '../_appCommon/base/UrlQueryDef';
import { Section } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [SystemServicesDataService,CustomerDataService, AnnouncementsService]
})
export class HomeComponent extends ControllerBase
{
  public announcements: any[] = [];
  public announcementsPreferences: number[] = [];
  public customerStatus:number=-1;
  constructor(private router: Router, private announcementsService: AnnouncementsService,private systemServicesDataService: SystemServicesDataService,private customerDataService:CustomerDataService)
  {
    super();
  }

  ngAfterViewInit(): void
  {
    this.getStartupInfo();
    this.getCustomerInfo();
  }

  ngOnInit() 
  {
    BroadcastManager.Instance.on(AppEventNames.OnCheckUserLoggedIn)
      .subscribe(([e]) =>
      {
        if (e[0])
          this.initializeUser();
      });

      this.getHideAnnouncements()
  }

  getHideAnnouncements(){
    let announcementsHidden = JSON.parse(localStorage.getItem('announcementsPreferences'));
    this.announcementsPreferences =  announcementsHidden ? announcementsHidden : [];

    this.getAnnouncements();
  }

  getAnnouncements(){
    var queryDef = new UrlQueryDef();
    queryDef.params = {};
    queryDef.params['withPagination'] = false;
    
    this.announcementsService.getAllAnnouncements(queryDef)
      .subscribe((response: any) =>
      {
        //Check if we have a paged result
        if (response.records != undefined && response.totalRecords != undefined)
        {
            this.announcements = response.records;
            this.announcements = this.announcements.filter(x=> !this.announcementsPreferences.includes(x.id) );
        }
        else
        {
            this.announcements = response;
            this.announcements = this.announcements.filter(x=> !this.announcementsPreferences.includes(x.id) );

        }
    });
  }

  hideAnnouncementsByCustomer(announcementId: number){
    this.announcementsPreferences.push(announcementId);
    localStorage.setItem('announcementsPreferences', JSON.stringify( this.announcementsPreferences));
    this.getAnnouncements();
  }


  private initializeUser():void
  {
    const user = AppClientContext.Instance.user;
    const customerStatus=AppClientContext.Instance.customerStatus;
    if (customerStatus)
    {
      this.customerStatus=customerStatus;
    }
  }

  private getStartupInfo()
  {
    this.systemServicesDataService.getStartupInfo()
      .subscribe((startupInfo) =>
      {
        this.onApplicationStartup(startupInfo);
      }, error =>
      {
        if (error.status == 401)
        {
          this.forceLogout();
        }
      });
  }

  private onApplicationStartup(startupInfo: any)
  {
    AppClientContext.Instance.initialize(startupInfo);
  }
  public forceLogout(): void
  {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');

    // Remove Token
    AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

    // Clear current user
    AppClientContext.Instance.user = null;
  }

  private getCustomerInfo() : void
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((response: any) =>
        {
          let currentCustomer = response.items.firstOrNull();
          if (currentCustomer)
          {
            AppClientContext.Instance.customerStatus=currentCustomer.customerStatus;
            this.customerStatus=currentCustomer.customerStatus;
          }
        });
    }
  }

  
}
